import { render } from "./NovoVoucher.vue?vue&type=template&id=03959922&scoped=true"
import script from "./NovoVoucher.vue?vue&type=script&lang=js"
export * from "./NovoVoucher.vue?vue&type=script&lang=js"

import "./NovoVoucher.vue?vue&type=style&index=0&id=03959922&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03959922"]])

export default __exports__